import apiClient from "./api";
const MATERIAL_API_BASE_URL = "/materiales";
class MaterialesService {
  getMateriales() {
    return apiClient.get(MATERIAL_API_BASE_URL);
  }
  agregarMaterial(material) {
    return apiClient.post(MATERIAL_API_BASE_URL, material);
  }
  updateMaterial(material, materialId) {
    return apiClient.put(MATERIAL_API_BASE_URL + "/" + materialId, material);
  }
  deleteMaterial(materialId) {
    return apiClient.delete(MATERIAL_API_BASE_URL + "/" + materialId);
  }
}
export default new MaterialesService();